import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uploadAttachments } from '../actions';

export const useUploadAttachments = () => {
    const dispatch = useDispatch();

    const onUpload = useCallback((files: File[]) => dispatch(uploadAttachments({ files })), [dispatch]);

    return {
        onUpload,
    };
};
